/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Tag } from "../models/Tag"

import type { CancelablePromise } from "../core/CancelablePromise"
import { OpenAPI } from "../core/OpenAPI"
import { request as __request } from "../core/request"

export class TagService {
  /**
   * Create Tag API Endpoint
   * Create Tag
   * @param companyId
   * @param requestBody
   * @param xAccessToken
   * @returns Tag successful operation
   * @throws ApiError
   */
  public static createTag(
    companyId: number,
    requestBody: {
      tag: string
    },
    xAccessToken?: string
  ): CancelablePromise<Tag> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/company/{companyId}/tag",
      path: {
        companyId: companyId,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        500: `Internal Server Error`,
      },
    })
  }

  /**
   * List Tag
   * List Tag
   * @param xAccessToken
   * @param companyId
   * @param orderBy
   * @param sortOrder
   * @param tag
   * @returns Tag successful operation
   * @throws ApiError
   */
  public static listTags(
    xAccessToken: string,
    companyId: number,
    orderBy?: string,
    sortOrder?: string,
    tag?: string
  ): CancelablePromise<Array<Tag>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/company/{companyId}/tag",
      path: {
        companyId: companyId,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      query: {
        orderBy: orderBy,
        sortOrder: sortOrder,
        tag: tag,
      },
      errors: {
        400: `Bad Request`,
        500: `Internal Server`,
      },
    })
  }

  /**
   * Get Tag API Endpoint
   * Get Tag
   * @param xAccessToken
   * @param companyId
   * @param tagId
   * @returns Tag successful operation
   * @throws ApiError
   */
  public static getTag(
    xAccessToken: string,
    companyId: number,
    tagId: number
  ): CancelablePromise<Tag> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/company/{companyId}/tag/{tagID}",
      path: {
        companyId: companyId,
        tagID: tagId,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        404: `Not Found`,
      },
    })
  }

  /**
   * Update Tag API Endpoint
   * Update Tag
   * @param companyId
   * @param tagId
   * @param requestBody
   * @param xAccessToken
   * @returns Tag successful operation
   * @throws ApiError
   */
  public static updateTag(
    companyId: number,
    tagId: number,
    requestBody: {
      tag?: string
    },
    xAccessToken?: string
  ): CancelablePromise<Tag> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/v1/company/{companyId}/tag/{tagID}",
      path: {
        companyId: companyId,
        tagID: tagId,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        500: `Internal Server Error`,
      },
    })
  }

  /**
   * Delete Tag API Endpoint
   * Delete Tag
   * @param xAccessToken
   * @param companyId
   * @param tagId
   * @returns void
   * @throws ApiError
   */
  public static deleteTag(
    xAccessToken: string,
    companyId: number,
    tagId: number
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/company/{companyId}/tag/{tagID}",
      path: {
        companyId: companyId,
        tagID: tagId,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        404: `Not Found`,
      },
    })
  }
}
